export const DEFAULT_START = '1776-07-04';
export const DEFAULT_END = '9999-12-31';

export const FRED_DEFAULTS = {
  fredSeries: [],
  fredFrequency: '',
  fredStart: DEFAULT_START,
  fredEnd: DEFAULT_END,
  fredUnits: 'lin',
  fredMoving: 'none',
  fredMethod: 'avg',
};

export const BLS_DEFAULTS = {
  blsPreset: '',
  blsSeries: [],
  blsStart: '',
  blsEnd: '',
  blsCalculations: 'none',
  blsMonths: '1',
  blsMoving: 'none',
  showBLSMessage: false,
  blsError: '',
};

export const ECON_DATA_PROPS = {
  fred: ['Start', 'End', 'Units', 'Moving', 'Frequency', 'Method'],
  bls: ['Preset', 'Series', 'Start', 'End', 'Calculations', 'Months', 'Moving'],
};

export const PRESETS = {
  'Select a chart': {},
  'Hiring History': {
    subdek: 'Percent change in total nonfarm jobs over the prior 12 months',
    series: { CES0000000001: 'Total nonfarm jobs' },
    start: '1990',
    calculationsType: 'pct',
    moving: 'none',
    months: '12',
    chartType: 'line',
  },
  'Wage Growth': {
    subdek: 'Change in average earnings from a year earlier',
    series: {
      CES0500000011: 'Weekly wages',
      CES0500000003: 'Hourly wages',
      CUSR0000SA0: 'Inflation rate',
    },
    start: '2007',
    calculationsType: 'pct',
    moving: 'none',
    months: '12',
    chartType: 'line',
  },
  'Prime-Age Participation': {
    subdek: 'Share of the prime-age (25-54 years old) population that is...',
    series: { LNS11300060: 'In the labor force', LNS12300060: 'Employed' },
    start: '2007',
    calculationsType: 'none',
    moving: 'none',
    suffix: '%',
    chartType: 'line',
  },
  'Broader Measures': {
    subdek: 'Alternate measures of the rates of unemployment and underemployment',
    series: {
      LNS13327709: 'Plus part-time for economic reasons',
      LNS13327708: 'Plus marginally attached',
      LNS13327707: 'Plus discouraged workers',
      LNS14000000: 'Headline unemployment rate',
    },
    start: '2000',
    calculationsType: 'none',
    moving: 'none',
    suffix: '%',
    chartType: 'line',
  },
  'Labor Force': {
    subdek: 'Share of the population that is...',
    series: { LNS11300000: 'In the labor force', LNS12300000: 'Employed' },
    start: '2007',
    calculationsType: 'none',
    moving: 'none',
    suffix: '%',
    chartType: 'line',
  },
  'Still Searching': {
    subdek: 'Median duration of unemployment',
    series: { LNS13008276: 'Median duration of unemployment' },
    start: '2007',
    calculationsType: 'none',
    moving: 'none',
    suffix: ' weeks',
    chartType: 'line',
  },
  'School Work': {
    subdek: 'Unemployment rate by educational attainment, ages 25 and over',
    series: {
      LNS14027659: 'Less than H.S.',
      LNS14027660: 'High school',
      LNS14027689: 'Some college',
      LNS14027662: 'College',
    },
    start: '1992',
    calculationsType: 'none',
    moving: 'none',
    suffix: '%',
    chartType: 'line',
  },
  'Men and Women at Work': {
    subdek: 'Unemployment rate by race/ethnicity and gender, age 20 and over',
    series: {
      LNS14000028: 'White men',
      LNS14000029: 'White women',
      LNS14000031: 'Black men',
      LNS14000032: 'Black women',
      LNS14000034: 'Hispanic men',
      LNS14000035: 'Hispanic women',
    },
    start: '2003',
    calculationsType: 'none',
    moving: 'none',
    suffix: '%',
    chartType: 'line',
  },
  'Unemployment rate': {
    subdek: '',
    series: { LNS14000000: 'Unemployment rate' },
    start: '2007',
    calculationsType: 'none',
    moving: 'none',
    suffix: '%',
    chartType: 'line',
  },
  'Monthly change in nonfarm payrolls': {
    subdek: '',
    series: { CES0000000001: 'Nonfarm payrolls' },
    start: '2015',
    calculationsType: 'net',
    months: '1',
    moving: 'none',
    suffix: ' thousand',
    chartType: 'column',
  },
};

export const FREQUENCIES = [
  { code: 'd', text: 'Daily' },
  { code: 'w', text: 'Weekly' },
  { code: 'wef', text: 'Weekly, Ending Friday' },
  { code: 'weth', text: 'Weekly, Ending Thursday' },
  { code: 'wew', text: 'Weekly, Ending Wednesday' },
  { code: 'wetu', text: 'Weekly, Ending Tuesday' },
  { code: 'wem', text: 'Weekly, Ending Monday' },
  { code: 'wesu', text: 'Weekly, Ending Sunday' },
  { code: 'wesa', text: 'Weekly, Ending Saturday' },
  { code: 'bw', text: 'Biweekly' },
  { code: 'bwew', text: 'Biweekly, Ending Wednesday' },
  { code: 'bwem', text: 'Biweekly, Ending Monday' },
  { code: 'm', text: 'Monthly' },
  { code: 'q', text: 'Quarterly' },
  { code: 'sa', text: 'Semiannual' },
  { code: 'a', text: 'Annual' },
];

export const UNITS = [
  { code: 'lin', text: 'Levels (No transformation)', suffix: '' },
  { code: 'chg', text: 'Change', suffix: '' },
  { code: 'ch1', text: 'Change from Year Ago', suffix: '' },
  { code: 'pch', text: 'Percent Change', suffix: '%' },
  { code: 'pc1', text: 'Percent Change from Year Ago', suffix: '%' },
  { code: 'pca', text: 'Compounded Annual Rate of Change', suffix: '%' },
  { code: 'cch', text: 'Continuously Compounded Rate of Change', suffix: '%' },
  { code: 'cca', text: 'Continuously Compounded Annual Rate of Change', suffix: '' },
  { code: 'log', text: 'Natural Log', suffix: '' },
];

export const UNITS_EXCEPTIONS = {
  britishPounds: ['U.S. $ to  1 British Pound', 'U.S. $ to  1 U.K. Pound Sterling'],
};

export const METHODS = [
  { code: 'avg', text: 'Average' },
  { code: 'sum', text: 'Sum' },
  { code: 'eop', text: 'End of Period' },
];

export const CALCULATIONS = [
  { value: 'none', text: 'Original data value' },
  { value: 'pct', text: 'Percent change' },
  { value: 'net', text: 'Net change' },
];

export const MOVING = [
  { value: 'none', code: 'none', text: 'None' },
  { value: '3', code: '3', text: '3-month' },
  { value: '6', code: '6', text: '6-month' },
];

export const MONTHS = ['1', '3', '6', '12'];

export function convertSource(text) {
  switch (text) {
    case 'Board of Governors of the Federal Reserve System (US)':
      return 'Federal Reserve';
    case 'U.S. Bureau of Labor Statistics':
      return 'Labor Department';
    case 'U.S. Bureau of Economic Analysis':
      return 'Commerce Department';
    default:
      return text;
  }
}

export function getColorTheme(hed, product) {
  switch (hed) {
    case 'Men and Women at Work':
      return `${product}_men_women`;
    case 'Wage Growth':
      return `${product}_wage_growth`;
    case 'Labor Force':
      return `${product}_labor_force`;
    case 'Prime-Age Participation':
      return `${product}_prime_age`;
  }
}
